import { defineComponent as _defineComponent } from 'vue'
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import TrashButton from "@/components-UI/buttons/TrashButton.vue";
import SvgTrash from "@/assets/icons/trash-white.svg";
import SvgReset from "@/assets/icons/reset-white-small.svg";
import { ITask } from "@/api/types/tasks";
import { computed, ref } from "vue";
import { FormattedItem } from "@/utils/CellsFactory";
import { deleteOneTask } from "@/api/tasks";
import { showServerError } from "@/utils";
import store from "@/store";
import { USER_ROLES } from "@/mappings/user-roles";

interface Props {
    task: FormattedItem<ITask> | ITask;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskDeleteTooltip',
  props: {
    task: null
  },
  emits: ['update-list'],
  setup(__props: any, { emit }) {

const props = __props as {
    task: FormattedItem<ITask> | ITask;
}




const deleteTask = async () => {
    try {
        const id = isTableItem(props.task) ? props.task.id.componentData.value : props.task.id;
        await deleteOneTask(id);
        emit('update-list');
    } catch (err) {
        showServerError(err, 'Задача не удалена');
    }
};

const tooltipEl = ref<InstanceType<typeof BaseTooltip> | null>(null);
const cancelDeleteTask = () => {
    tooltipEl.value?.closeTooltip();
};
const isActiveTooltip = computed(() => tooltipEl.value?.isShowTooltip);

const isCanDelete = computed(() => {
    const isDeleted = isTableItem(props.task) ? props.task.status.componentData.value === 'deleted' : props.task.status === 'deleted';
    if (isDeleted) return false;
    const user = store.getters['authModule/GET_USER'];
    const isAdmin = user.roles.includes(USER_ROLES.ADMIN);
    const createdById = isTableItem(props.task) ? props.task.created_by.componentData.value.id : props.task.created_by.id;
    const isAuthor = user.account_id === createdById;
    return isAuthor || isAdmin;
});

const isTableItem = (task: FormattedItem<ITask> | ITask): task is FormattedItem<ITask> => {
    return (task as FormattedItem<ITask>).id.componentData !== undefined;
};

return { __sfc: true,props, emit, deleteTask, tooltipEl, cancelDeleteTask, isActiveTooltip, isCanDelete, isTableItem, BaseTooltip, TrashButton, SvgTrash, SvgReset }
}

})